module.exports = __webpack_public_path__ + "img/home-banner.e1d30b1e.jpg";